import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

// The submitted modal's layout (SubmitConfirmedModal), with a quieter line for
// Logyx core's own text.
export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10rem;
  padding: 20rem;

  ${respondTo.bigPhone`
    padding-top: 40rem;
  `}
`;

export const Text = styled.label`
  font-weight: 400;
  font-size: 24rem;
  line-height: 32rem;
  color: ${COLORS.BLACK};
  text-align: center;

  ${respondTo.bigPhone`
    font-size: 20rem;
    line-height: 1.3;
  `}
`;

export const Detail = styled.p`
  margin: 10rem 0 0;
  font-weight: 300;
  font-size: 16rem;
  line-height: 24rem;
  color: ${COLORS.BLACK};
  opacity: 0.75;
  text-align: center;
`;
